import { Head } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import filterhawkLogo from '@/assets/filterhawk.svg'
import filterhawkLogoWhite from '@/assets/filterhawk-white.svg'

export default function Landing() {
  return (
    <>
      <Head title="FilterHawk" />
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <div className="mb-8">
          <div className="flex justify-center mb-4">
            <img
              src={filterhawkLogo}
              alt="FilterHawk"
              className="h-20 w-auto dark:hidden"
            />
            <img
              src={filterhawkLogoWhite}
              alt="FilterHawk"
              className="h-20 w-auto hidden dark:block"
            />
          </div>
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
            Better filters for your Gmail inbox.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild size="lg" className="text-lg px-8">
            <a href="/signup">Get Started</a>
          </Button>
          <Button asChild variant="outline" size="lg" className="text-lg px-8 dark:text-white">
            <a href="/login">Log In</a>
          </Button>
        </div>
      </div>
    </div>
    </>
  )
}
